/* RESPONSIBLE TEAM: team-fin-qa */

import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { type Router } from '@ember/routing';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorRoute extends Route {
  @service declare appService: AppService;
  @service declare router: Router;

  queryParams = {
    interval: { refreshModel: false },
  };

  analytics = {
    section: 'standalone',
    place: 'monitor',
  };

  reactEnabled() {
    return true;
  }

  async beforeModel() {
    if (!this.appService.app.canSeeMonitor) {
      this.router.transitionTo('apps.app.standalone.performance');
    }
  }
}

export default ReactRoute(StandaloneMonitorRoute, {
  overrideRenderTemplate: false,
});
